import {
  GET_LEGALSTATUS,
  GET_LEGALSTATUS_SUCCESS,
  GET_LEGALSTATUS_FAIL,
  DELETE_LEGALSTATUS,
  DELETE_LEGALSTATUS_SUCCESS,
  DELETE_LEGALSTATUS_FAIL,
  UPDATE_LEGALSTATUS,
  UPDATE_LEGALSTATUS_SUCCESS,
  UPDATE_LEGALSTATUS_FAIL,
  ADD_NEW_LEGALSTATUS,
  ADD_LEGALSTATUS_SUCCESS,
  ADD_LEGALSTATUS_FAIL,
  LEGALSTATUS_LOADING,
  LEGALSTATUS_RESET,
} from "./actionType";

export const resetLegalStatusState = (actionType) => ({
  type: LEGALSTATUS_RESET,
  payload: { actionType },
});

export const getLegalStatusSuccess = (actionType, data) => ({
  type: GET_LEGALSTATUS_SUCCESS,
  payload: { actionType, data },
});

export const getLegalStatusFail = (actionType, error) => ({
  type: GET_LEGALSTATUS_FAIL,
  payload: { actionType, error },
});

export const getLegalStatus = (data) => ({
  type: GET_LEGALSTATUS,
  payload: data,
});

export const getLegalStatusLoading = () => ({
  type: LEGALSTATUS_LOADING,
});

export const deleteLegalStatus = (data) => ({
  type: DELETE_LEGALSTATUS,
  payload: data,
});

export const deleteLegalStatusSuccess = (data) => ({
  type: DELETE_LEGALSTATUS_SUCCESS,
  payload: data,
});

export const deleteLegalStatusFail = (error) => ({
  type: DELETE_LEGALSTATUS_FAIL,
  payload: error,
});

export const updateLegalStatus = (data) => ({
  type: UPDATE_LEGALSTATUS,
  payload: data,
});

export const updateLegalStatusFail = (error) => ({
  type: UPDATE_LEGALSTATUS_FAIL,
  payload: error,
});

export const updateLegalStatusSuccess = (data) => ({
  type: UPDATE_LEGALSTATUS_SUCCESS,
  payload: data,
});

export const addNewLegalStatus = (data) => ({
  type: ADD_NEW_LEGALSTATUS,
  payload: data,
});

export const addLegalStatusSuccess = (data) => ({
  type: ADD_LEGALSTATUS_SUCCESS,
  payload: data,
});

export const addLegalStatusFail = (error) => ({
  type: ADD_LEGALSTATUS_FAIL,
  payload: error,
});
